var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickFeedbackAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_141_1",
    "data-name": "Componente 141 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_311",
    "data-name": "Grupo 311",
    transform: "translate(5.893 6.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    d: "M27.108,0A27.108,27.108,0,1,1,0,27.108,27.108,27.108,0,0,1,27.108,0Z",
    transform: "translate(0 0)",
    fill: "#efb650"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_222",
    "data-name": "Trazado 222",
    d: "M23.793,0A23.793,23.793,0,1,1,0,23.793,23.793,23.793,0,0,1,23.793,0Z",
    transform: "translate(3.315 1.36)",
    fill: "#fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_198",
    "data-name": "Trazado 198",
    d: "M918.042,860.861",
    transform: "translate(-901.567 -853.837)",
    fill: "none",
    stroke: "#47476b",
    strokeWidth: 8.414
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_199",
    "data-name": "Trazado 199",
    d: "M933.444,846.032h0a5.683,5.683,0,0,0-8.462-2.268h0",
    transform: "translate(-906.285 -841.358)",
    fill: "none",
    stroke: "#47476b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_200",
    "data-name": "Trazado 200",
    d: "M983.477,873.394h0a5.684,5.684,0,0,1,8.463,2.267h0",
    transform: "translate(-946.294 -861.622)",
    fill: "none",
    stroke: "#47476b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_201",
    "data-name": "Trazado 201",
    d: "M926.045,947.407a11.652,11.652,0,0,0,16.478,0",
    transform: "translate(-906.966 -912.992)",
    fill: "none",
    stroke: "#47476b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_223",
    "data-name": "Trazado 223",
    d: "M0,0H8.527V2.88H0Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 26.67, 12.314)",
    fill: "#e25454",
    stroke: "#e25454",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_224",
    "data-name": "Trazado 224",
    d: "M4.794,0H16.1A4.794,4.794,0,0,1,20.89,4.794h0A11.735,11.735,0,0,1,9.155,16.529H7.663A7.663,7.663,0,0,1,0,8.866V4.794A4.794,4.794,0,0,1,4.794,0Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 9.394, 7.024)",
    fill: "#47476b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_225",
    "data-name": "Trazado 225",
    d: "M7.351,0H8.781A11.257,11.257,0,0,1,20.038,11.257a4.6,4.6,0,0,1-4.6,4.6H4.6a4.6,4.6,0,0,1-4.6-4.6V7.351A7.351,7.351,0,0,1,7.351,0Z",
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 47.811, 34.152)",
    fill: "#47476b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_226",
    "data-name": "Trazado 226",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 9.29, 6.885)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.857,0h11.45a4.857,4.857,0,0,1,4.857,4.857h0A11.889,11.889,0,0,1,9.274,16.745H7.763A7.763,7.763,0,0,1,0,8.982V4.857A4.857,4.857,0,0,1,4.857,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.856582641601562 1.999997138977051 C 3.281461715698242 1.999997138977051 2.000001907348633 3.28145694732666 2.000001907348633 4.856587409973145 L 2.000001907348633 8.981927871704102 C 2.000001907348633 12.15979766845703 4.585382461547852 14.74517726898193 7.763252258300781 14.74517726898193 L 9.274332046508789 14.74517726898193 C 14.72694206237793 14.74517726898193 19.16296195983887 10.30914688110352 19.16296195983887 4.856536865234375 C 19.16296195983887 3.281436920166016 17.88152122497559 1.999997138977051 16.30642127990723 1.999997138977051 L 4.856582641601562 1.999997138977051 M 4.856582641601562 -1.9073486328125e-06 L 16.30642127990723 -1.9073486328125e-06 C 18.98861122131348 -1.9073486328125e-06 21.16296195983887 2.174346923828125 21.16296195983887 4.856536865234375 C 21.16296195983887 11.42244720458984 15.84024238586426 16.74517631530762 9.274332046508789 16.74517631530762 L 7.763252258300781 16.74517631530762 C 3.47572135925293 16.74517631530762 1.9073486328125e-06 13.26944732666016 1.9073486328125e-06 8.981927871704102 L 1.9073486328125e-06 4.856587409973145 C 1.9073486328125e-06 2.17436695098877 2.174371719360352 -1.9073486328125e-06 4.856582641601562 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#e25454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_227",
    "data-name": "Trazado 227",
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 48.239, 34.726)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.763,0H9.274A11.889,11.889,0,0,1,21.163,11.889h0a4.857,4.857,0,0,1-4.857,4.857H4.856A4.856,4.856,0,0,1,0,11.889V7.763A7.763,7.763,0,0,1,7.763,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.763249397277832 1.999997138977051 C 4.585378646850586 1.999997138977051 1.999998092651367 4.585376739501953 1.999998092651367 7.763247489929199 L 1.999998092651367 11.88868713378906 C 1.999998092651367 13.46375751495361 3.28141975402832 14.74517726898193 4.856489181518555 14.74517726898193 L 16.30632972717285 14.74517726898193 C 17.8814582824707 14.74517726898193 19.16291809082031 13.46371746063232 19.16291809082031 11.88858699798584 C 19.16291809082031 6.435997009277344 14.72691917419434 1.999997138977051 9.27432918548584 1.999997138977051 L 7.763249397277832 1.999997138977051 M 7.763249397277832 -1.9073486328125e-06 L 9.27432918548584 -1.9073486328125e-06 C 15.84021949768066 -1.9073486328125e-06 21.16291999816895 5.322707176208496 21.16291999816895 11.88858699798584 C 21.16291999816895 14.57080745697021 18.98854827880859 16.74517631530762 16.30632972717285 16.74517631530762 L 4.856489181518555 16.74517631530762 C 2.174318313598633 16.74517631530762 -1.9073486328125e-06 14.5708475112915 -1.9073486328125e-06 11.88868713378906 L -1.9073486328125e-06 7.763247489929199 C -1.9073486328125e-06 3.475727081298828 3.475719451904297 -1.9073486328125e-06 7.763249397277832 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#e25454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146",
    transform: "translate(7.303 6.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_202",
    "data-name": "Trazado 202",
    d: "M895.738,861.084l-5.466-1.465a.643.643,0,0,0-.788.455l-.239.891a1.677,1.677,0,0,0,1.186,2.055h0Z",
    transform: "translate(-889.189 -859.597)",
    fill: "#e25454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147",
    transform: "translate(48.006 17.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_203",
    "data-name": "Trazado 203",
    d: "M1017.808,893.2l5.465,1.464a.644.644,0,0,1,.455.788l-.239.891a1.677,1.677,0,0,1-2.054,1.186h0Z",
    transform: "translate(-1017.808 -893.202)",
    fill: "#e25454"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_204",
    "data-name": "Trazado 204",
    d: "M937.373,884.571a2.074,2.074,0,1,1-1.467-2.54A2.074,2.074,0,0,1,937.373,884.571Z",
    transform: "translate(-911.992 -868.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_205",
    "data-name": "Trazado 205",
    d: "M929.077,894.64a.934.934,0,1,1-.66-1.144A.934.934,0,0,1,929.077,894.64Z",
    transform: "translate(-907.858 -876.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_206",
    "data-name": "Trazado 206",
    d: "M1010.742,904.23a2.074,2.074,0,1,1-1.467-2.54A2.074,2.074,0,0,1,1010.742,904.23Z",
    transform: "translate(-962.14 -881.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_207",
    "data-name": "Trazado 207",
    d: "M1002.446,914.3a.934.934,0,1,1-.66-1.143A.933.933,0,0,1,1002.446,914.3Z",
    transform: "translate(-958.074 -889.538)",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_112",
    "data-name": "Rect\\xE1ngulo 112",
    width: 66,
    height: 66,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickFeedbackAlert);
export default __webpack_public_path__ + "static/media/quick-feedback-alert.c77ddf7532c36211ddafadaac55339a2.svg";
export { ForwardRef as ReactComponent };